import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  tableContainer: {
    marginTop: 30,
    borderTop: 10
  },
  colorColumn: {
    borderTop: '2px solid black'
  }
}));
